import { faqComputadorDaEmpresa, faqCusto, faqDados, faqProgramar } from './shared'
import type { ProfessionPageConfig } from './types'

export const secretariaEscolar: ProfessionPageConfig = {
  path: '/ia-para-secretaria-escolar/',
  key: 'escola',
  title: 'IA para secretaria escolar e coordenação | Oficina IA',
  description:
    'Três tarefas da secretaria da escola que a IA adianta numa pasta: declarações a partir da lista de alunos, a cobrança do mês e relatórios escolares.',
  imageAlt: 'Oficina IA: IA para secretaria escolar',
  whatsappMessage: 'Olá, Arthur. Vim pela página de IA para secretaria escolar e quero saber sobre o acompanhamento.',
  lastmod: '2026-09-25',
  heading: 'IA para secretaria escolar',
  intro:
    'Eu toquei uma escola de idiomas e sei: matrícula, declaração, cobrança e relatório saem todos da mesma lista de alunos, digitados de novo a cada vez. Aqui estão três tarefas dessa rotina que a IA pode ajudar a adiantar, sem programar.',
  rogerio: { pose: 'conferindo', text: 'A lista de alunos é uma só. O resto sai dela.' },
  tasks: [
    {
      title: 'Declarações a partir da lista',
      tone: 'sky',
      brings: 'um modelo em branco e a lista de alunos.',
      helps: 'preenche uma declaração por aluno e salva na pasta.',
      continues: 'confere algumas e assina.',
    },
    {
      title: 'A cobrança do mês',
      tone: 'peach',
      brings: 'a lista exportada do sistema e a tabela de descontos.',
      helps: 'monta a planilha com os valores certos e uma mensagem pronta por responsável.',
      continues: 'confere dois ou três e manda.',
    },
    {
      title: 'Relatórios escolares',
      tone: 'sage',
      brings: 'as notas e as observações dos professores.',
      helps: 'escreve um relatório por aluno no modelo da escola.',
      continues: 'a coordenação lê e ajusta antes de entregar.',
    },
  ],
  steps: {
    do: 'A IA preenche as declarações, monta a planilha ou escreve os relatórios dentro da sua pasta.',
    check: 'Abra alguns e compare com a lista. A IA pode se enganar; a assinatura é sua.',
    resume: 'No mês seguinte, troque a lista e repita o pedido.',
  },
  faq: [faqProgramar, faqComputadorDaEmpresa, faqDados('dos alunos'), faqCusto],
  closing: {
    title: 'A primeira leva de declarações, com alguém do lado.',
    text: 'Traga a lista de matrículas, a cobrança do mês ou o relatório que a direção pediu.',
    rogerio: 'Eu cuido do novelo. Você cuida da secretaria.',
  },
}
